import React from 'react'
import { Mutation } from "react-apollo";
import Form from "../components/form";
import { EDIT, GET_BY_ID } from "../../../queries/pushNotification";

const Update = (props) => {
  
  return (
    <Mutation
      mutation={EDIT}
      update={(cache, { data: { updateMessage } }) => {
        const { messages } = cache.readQuery({ query: GET_BY_ID, variables: { publisherId: localStorage.getItem('publisher-active') } });
        cache.writeQuery({
          query: GET_BY_ID,
          variables: { publisherId: localStorage.getItem('publisher-active') },
          data: { messages: messages }
        });
      }}
      >
      {updateMessage => (
       <Form query_f = {updateMessage} {...props} />
      )}
    </Mutation>
  );
};

export default Update;